<template>
  <div>
	<vheader></vheader>
		<router-view/>
	<vfooter></vfooter>
  </div>
</template>

<script>
	import vheader from '@/components/header'
	import vfooter from '@/components/footer'
	export default {
	  name: 'App',
		components:{
			vheader,
			vfooter
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue